import React, { useContext, useLayoutEffect, useState } from 'react';
import styled from 'styled-components';
import BurgerMenu from '../navigation/BurgerMenu';
import { InitialMenu } from '../../constants/InitialMenu';
import MenuItem from './MenuItem';
import { useGlobalState } from '../stateProvider/StateProvider';
import { useLocation } from 'react-router-dom';
import { MenuContext } from './Body';
import RoleProtected from '../RoleProtected';
import Card from '../forms/Card';
import Seasonal from '../Seasonal';
import { SCREEN_MAX_WIDTH } from '../../constants/config';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100svh;
    display: flex;
    flex-direction: column;
    background: ${({ theme }) => theme.primary};
    overscroll-behavior: contain;
    align-items: flex-start;
    gap: 0.5em;
    width: ${({ open }) => open ? '300px' : '100px'};
    min-width: ${({ open }) => open ? '300px' : '100px'};
    position: relative;
    transition: all 0.13s ease-in-out;
    overflow-x: hidden;
    overflow-y: auto;
    box-shadow: 5px 0px 10px ${({ theme }) => theme.shadow};
    border-right: 3px solid ${({ theme }) => theme.tertiary};


    @media (max-width: ${SCREEN_MAX_WIDTH}) {
        position: absolute;
        left: 0;
        width: ${({ open }) => open ? '75svw' : '0px'};
        min-width: ${({ open }) => open ? '75svw' : '0px'};
        z-index: 5;
    }
`
const MenuHeader = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 4em;
    align-items: flex-start;
    justify-content: center;
    user-select: none;

    @media (max-width: ${SCREEN_MAX_WIDTH}) {
        width: 100%;
        position: sticky;
        top 0;
        background: ${({ theme }) => theme.primary};
        z-index: 5;
    }
`
const MenuBackdrop = styled.div`
    position: absolute;
    height: 100%;
    left: 0;
    width: ${({ open }) => open ? '100svw' : '0px'};
    transition: all 0.13s ease-in-out;
    background: ${({ theme }) => theme.shadow};
    z-index: 4;
    display: none;

    @media (max-width: ${SCREEN_MAX_WIDTH}) {
        display: block;
    }
`
const MenuContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 80%;
    padding: 1em;
    width: -webkit-fill-available;
    width: -moz-available;
    gap: 0.2em;
`
const Burger = styled(BurgerMenu)`
    margin-left: 30px;

    @media (max-width: ${SCREEN_MAX_WIDTH}) {
        display: none;
    }
`
const ToolTip = styled(Card)`
    position: absolute;
    padding: 0.5em;

    background: ${({ theme }) => theme.background};

    z-index: 100;
    pointer-events: none;

    transition: opacity 0.2s;

    @media (max-width: ${SCREEN_MAX_WIDTH}) {
        display: none;
    }
`

const SideBar = ({ children, ...props }) => {
    useLocation();

    const {
        state: { locations },
        logOut,
    } = useGlobalState();

    const [menu, setMenu] = useState(InitialMenu);
    const [hoverTip, setTooltip] = useState({ label: '', pos: [0, 0], opacity: 0 });
    const [openIndex, setOpenIndex] = useState(null);

    useLayoutEffect(() => {
        if (locations.length === 0) {
            setMenu(menu.filter(e => e.path !== '/locations'))
        } else {
            setMenu(InitialMenu)
        }
    }, [locations])

    const setHoverTip = (event, label, opacity) => {
        setTooltip({ label: label, pos: [event.clientX, event.clientY], opacity: opacity })
    }

    const { isOpen, setIsOpen } = useContext(MenuContext);

    return (
        <>
            <ToolTip
                style={{
                    left: `${hoverTip.pos[0] + 20}px`,
                    top: `${hoverTip.pos[1]}px`,
                    opacity: isOpen ? 0 : hoverTip.opacity
                }}
            >
                <b>{hoverTip.label}</b>
            </ToolTip>

            <Wrapper open={isOpen}>
                <Seasonal />
                <MenuHeader open={isOpen}>
                    <Burger />
                </MenuHeader>
                <MenuContent>
                    {menu.map((e, i) => (
                        <RoleProtected roles={e.role} key={`menuItem-${i}`}>
                            <MenuItem
                                onMouseMove={(event) => setHoverTip(event, e.label, 1)}
                                onMouseLeave={(event) => setHoverTip(event, e.label, 0)}
                                expanded={openIndex === i}
                                onExpandChange={(value) => setOpenIndex(value ? i : null)}
                                {...e}
                            />
                        </RoleProtected>
                    ))}
                    <MenuItem
                        onMouseMove={(event) => setHoverTip(event, 'Log Out', 1)}
                        onMouseLeave={(event) => setHoverTip(event, 'Log Out', 0)}
                        icon='signOut'
                        label='Log Out'
                        onClick={logOut}
                    />
                </MenuContent>
            </Wrapper>
            <MenuBackdrop open={isOpen} onClick={() => setIsOpen(false)} />
        </>
    );
}

export default SideBar;
